export enum AlertDialogType {
  Danger,
  Info,
  Warning,
}

export namespace AlertDialogType {
  export const name = (type?: AlertDialogType) => {
    switch (type) {
      case AlertDialogType.Danger:
        return 'common.alert.types.continue';
      case AlertDialogType.Warning:
        return 'common.alert.types.warning';
      default:
        return 'common.alert.types.info';
    }
  };

  export const dialogClassName = (type?: AlertDialogType) => {
    switch (type) {
      case AlertDialogType.Danger:
        return 'danger-dialog';
      case AlertDialogType.Warning:
        return 'warning-dialog';
      default:
        return 'info-dialog';
    }
  };

  export const buttonClassName = (type?: AlertDialogType) => {
    switch (type) {
      case AlertDialogType.Danger:
        return 'sem-critical';
      case AlertDialogType.Warning:
        return 'sem-medium';
      default:
        return '';
    }
  };
}
